import { __module as o } from "../../../../_virtual/objectWithoutPropertiesLoose.js";
var s;
function f() {
  return s ? o.exports : (s = 1, function(e) {
    function u(t, n) {
      if (t == null) return {};
      var i = {};
      for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
        if (n.indexOf(r) !== -1) continue;
        i[r] = t[r];
      }
      return i;
    }
    e.exports = u, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(o), o.exports);
}
export {
  f as __require
};
